<template>
  <v-card class="recorder card--flex--toolbar">
    <v-card-title class="px-1 pb-0">
      <v-toolbar flat class="px-3">
        <v-row dense class="px-4 mb-2">
          <v-col :cols="isRequiredRemover ? '11' : '12'">
            <v-combobox
              v-model="form.title"
              ref="titler"
              :label="isSetId ? '投稿タイトル' : '新規投稿'"
              :items="getTitleItems"
              maxlength="100"
              :search-input.sync="form.search.title"
            />
            <v-dialog scrollable v-model="config.filer.active" max-width="800">
              <v-card class="px-0" width="100%">
                <v-card-text class="px-0">
                  <Filer v-if="config.filer.active"
                    :rid="getRootMediaId"
                    :cid="getClientId"
                    :fixedRoot="true"
                    :filters="{ ids: getAttachmentIds }"
                    @select="selectAttachments"
                  />
                </v-card-text>
                <v-card-actions>
                  <v-btn text color="secondary" @click.stop="closeFiler">閉じる</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn depressed color="secondary" :disabled="!store.attachments.length" @click.stop="setAttachments">選択する</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
          <v-col cols="1" v-if="isRequiredRemover" align="center">
            <v-tooltip v-if="isRequiredRemover" top>
              <template v-slot:activator="{ on }">
                <v-btn fab depressed x-small
                  v-on="on"
                  color="red white--text"
                  @click.stop="remove">
                  <v-icon small>fal fa-trash-alt</v-icon>
                </v-btn>
              </template>
              <span>削除する</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <template v-slot:extension v-if="!isSetClient">
          <v-row dense class="pb-2">
            <v-col cols="12">
              <v-autocomplete validate-on-blur
                ref="searcher"
                v-model="form.cid"
                color="primary"
                label="顧客を検索する"
                :no-data-text="printNoDataText"
                :items="getClientItems"
                :loading="isSearching"
                :search-input.sync="form.search.client"
                :rules="rules.required"
              />
            </v-col>
          </v-row>
        </template>
      </v-toolbar>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-textarea counter
        v-model="form.content"
        label="何がありましたか？"
        maxlength="1000"
      />
      <div class="text-xs-left" v-if="getAttachments.length">
        <div class="caption grey--text text--darken-1">添付ファイル</div>
        <v-chip v-for="item in getAttachments" :key="item.id" close @click:close="removeAttachment(item)">{{ item.name }}</v-chip>
      </div>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn v-if="isRequiredCloser" text color="secondary" @click.stop="close">閉じる</v-btn>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon
            v-on="on"
            color="secondary"
            class="mr-2"
            :disabled="!getClientId"
            @click.stop="openFiler">
            <v-icon small>fal fa-paperclip</v-icon>
          </v-btn>
        </template>
        <span>ファイルを添付する</span>
      </v-tooltip>
      <v-btn depressed
        color="secondary"
        :loading="isLoading"
        :disabled="!isPostable"
        @click="post">
        <v-icon small class="mr-2">{{ isSetId ? 'fal fa-sync' : 'fal fa-paper-plane' }}</v-icon>
        {{ isSetId ? '更新する' : '投稿する' }}
      </v-btn>
    </v-card-actions>
    <Confirmer ref="confirmer" />
  </v-card>
</template>

<script>
import _ from 'lodash'
import Filer from '@/components/filers/client'
import Confirmer from '@/components/modals/confirm'
export default {
  name: 'recorder',
  components: {
    Filer,
    Confirmer
  },
  props: [
    'client',
    'closer',
    'remover'
  ],
  data () {
    return {
      config: {
        status: {
          loading: false,
          searching: false
        },
        filer: {
          active: false
        }
      },
      form: {
        id: '',
        cid: '',
        search: {
          title: '',
          client: ''
        },
        title: '',
        content: '',
        attachments: []
      },
      rules: {
        required: [
          v => !!v || '必須項目です'
        ]
      },
      store: {
        titles: [],
        clients: [],
        attachments: [],
        unimports: []
      }
    }
  },
  mounted () {
  },
  methods: {
    onSubmit: function () { return false },
    init: function (req) {
      const { id, cid, title, content, attachments } = req || {}
      this.$set(this.config, 'status', {
        loading: false,
        searching: false
      })
      this.$set(this, 'form', {
        id: id || '',
        cid: cid || '',
        search: {
          title: '',
          client: ''
        },
        title: title || '',
        content: content || '',
        attachments: !attachments ? [] : JSON.parse(JSON.stringify(attachments))
      })
    },
    post: function () {
      if (this.$refs.titler) {
        this.$refs.titler.blur()
      }
      this.$nextTick(() => {
        const { id, title, content } = this.form
        if (!title && !content) {
          this.$refs.confirmer.open({
            message: 'タイトルと投稿内容が空欄になっていますが投稿しますか？',
            callback: () => {
              this.submit({ type: !id ? 'insert' : 'update' })
            }
          })
        } else {
          this.submit({ type: !id ? 'insert' : 'update' })
        }
      })
    },
    remove: function () {
      this.$refs.confirmer.open({
        message: 'この投稿を削除してもよろしいですか？',
        callback: () => {
          this.submit({ type: 'remove' })
        }
      })
    },
    preSubmit: function (req) {
      const { type } = req || {}
      const { id, search, title, content, attachments } = this.form
      const aid = this.$store.getters['author/get']('userid')
      const cid = this.$route.params.id || this.form.cid
      const developer = this.$store.getters['author/get']('roles').includes('developer')
      const urls = {
        title: `${this.$url.api}posts/get/titles`,
        client: `${this.$url.api}client/get/items`,
        insert: `${this.$url.api}posts/insert/item/${cid}`,
        update: `${this.$url.api}posts/update/item/${id}`,
        remove: `${this.$url.api}posts/remove/item/${id}`
      }
      const fds = {
        title: { title: search.title },
        client: { name: search.client },
        insert: { aid, title, content, attachments },
        update: { cid, aid, title, content, attachments, developer },
        remove: { cid, aid, type: 'record' }
      }
      if (type && urls[type] && fds[type]) {
        if ([ 'insert', 'update', 'remove' ].includes(type)) {
          const url = urls[type]
          const fd = fds[type]
          this.$set(this.config.status, 'loading', true)
          return { url, fd, type }
        } else if (type === 'title' && search.title) {
          const url = urls[type]
          const fd = fds[type]
          this.$set(this.config.status, 'searching', true)
          return { url, fd, type }
        } else if (type === 'client' && search.client) {
          const url = urls[type]
          const fd = fds[type]
          this.$set(this.config.status, 'searching', true)
          return { url, fd, type }
        } else {
          return false
        }
      } else {
        return false
      }
    },
    submit: function (req) {
      const dt = this.preSubmit(req)
      if (dt) {
        const { url, fd, type } = dt
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(url, fd, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.postSubmit(res.data.data, type)
            } else {
              this.failSubmit()
            }
          }).catch(err => {
            console.log(err)
            this.failSubmit()
          })
        })
      }
    },
    postSubmit: function (req, postType) {
      const socket = this.$store.getters['config/get']('socket')
      const type = postType || ''
      if (type === 'title') {
        this.$set(this.config.status, 'searching', false)
        this.$set(this.store, 'titles', req)
      } else if (type === 'client') {
        this.$set(this.config.status, 'searching', false)
        this.$set(this.store, 'clients', req)
      } else {
        if (!socket.connected) {
          socket.connect()
        }
        socket.emit('POST_POST', req, (res) => {
          console.log(res)
          this.$emit('done', req)
          this.init()
          this.$set(this.config.status, 'loading', false)
        })
      }
    },
    failSubmit: function (req) {
      this.$set(this.config.status, 'loading', false)
    },
    close: function () {
      this.$emit('close')
    },
    searchTitle: _.debounce(function (val) {
      this.submit({ type: 'title' })
    }, 300),
    searchClient: _.debounce(function (val) {
      this.submit({ type: 'client' })
    }, 300),
    selectAttachments: function (items) {
      let selects = items ? items.filter(it => {
        return (it.id && it.type && it.type !== 'folder')
      }) : []
      this.$set(this.store, 'attachments', selects)
    },
    setAttachments: function () {
      this.$set(this.form, 'attachments', this.form.attachments.concat(this.store.attachments))
      this.closeFiler()
    },
    removeAttachment: function (item) {
      if (item.id) {
        let idx = this.form.attachments.findIndex(it => {
          return it.id === item.id
        })
        if (idx >= 0) {
          this.form.attachments.splice(idx, 1)
        }
      }
    },
    selectUnimports: function (items) {
      let selects = items ? items.filter(it => {
        return (it.id && it.type && it.type !== 'folder')
      }) : []
      this.$set(this.store, 'unimports', selects)
    },
    openFiler: function () {
      this.$set(this.config.filer, 'active', true)
    },
    closeFiler: function () {
      this.$set(this.config.filer, 'active', false)
      this.$set(this.store, 'attachments', [])
    }
  },
  watch: {
    'form.search.title': function (newVal, oldVal) {
      if (newVal && oldVal && newVal.length < oldVal.length) {
        this.$set(this.store, 'titles', [])
      }
      if (!this.config.status.searching && !this.store.titles.length) {
        this.searchTitle()
      }
    },
    'form.search.client': function (newVal, oldVal) {
      if (newVal && oldVal && newVal.length < oldVal.length) {
        this.$set(this.store, 'clients', [])
      }
      if (!this.config.status.searching && !this.store.clients.length) {
        this.searchClient()
      }
    }
  },
  computed: {
    isLoading () {
      return this.config.status.loading
    },
    isSearching () {
      return this.config.status.searching
    },
    isSetClient () {
      return this.$route.params.id
    },
    isSetId () {
      return this.form && this.form.id
    },
    isPostable () {
      return this.form.title || this.form.content
    },
    isRequiredCloser () {
      return this.$props.closer
    },
    isRequiredRemover () {
      return this.$props.remover
    },
    printNoDataText () {
      return this.form.search.client ? '検索結果0件です' : 'ふりがな or 名前を入力してください'
    },
    getTitleItems () {
      return this.store.titles.length ? this.store.titles : []
    },
    getClientItems () {
      return this.store.clients.length ? this.store.clients.map(it => {
        return {
          text: `${it.name.replace(',', '')}（${it.kana.replace(',', '')}）`,
          value: it.id
        }
      }) : []
    },
    getAttachments () {
      return this.form.attachments
    },
    getAttachmentIds () {
      return this.form.attachments.map(it => {
        return it.id
      })
    },
    getRootMediaId () {
      return this.$store.getters['client/get']('lib').media
    },
    getClientId () {
      return this.$route.params.id || this.form.cid
    },
    hasUnimports () {
      return !!this.store.unimports.length
    }
  }
}
</script>

<style lang="scss">
.recorder {
  .v-toolbar__content {
    padding: 1rem 0 0;
  }
}
</style>
